import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@components/ui';
import AllyConnectLogo from '@components/ui/icons/AllyConnectLogo';

const ForbiddenPage: React.FC = () => (
  <div className="forbidden-page min-h-[calc(100vh-64px)] bg-au-body-updated px-4 py-10">
    <div className="flex min-h-[calc(100vh-64px-80px)] items-center justify-center">
      <div className="flex w-full flex-col items-center gap-6 text-center">
        <AllyConnectLogo className="flex items-center gap-3 ally-connect" />

        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-3">
            <h1 className="whitespace-nowrap text-center text-[24px] font-medium leading-8 tracking-[-0.24px] text-warning">
              403. You don&apos;t have access to this page.
            </h1>
            <p className="w-full max-w-[521px] whitespace-pre-wrap text-center text-[16px] font-[370] leading-6 text-au-text-secondary">
              {' This page is available for a different role.'}
              <br />
              {' Head back to your dashboard or check your access with your admin.'}
            </p>
          </div>

          <Link to="/">
            <Button
              size="lg"
              className="min-w-[88px] rounded-[50px] border-0 px-7 py-[18px] text-[16px] font-medium leading-5 text-white shadow-none forbidden-page__cta"
            >
              Go to dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default ForbiddenPage;
